var _path, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeduzaLoader = function SvgMeduzaLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 433.38 503.98"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m395.44 264.05 37.09 3.15c5.76-76.8-17.69-142.72-71.29-199.15l14.71-13.51A269.4 269.4 0 0 0 295.88 0l-13.41 28.84c-46.56-20.82-95-21.47-118-17.86.25 3.28.48 6.58.74 9.89s.55 6.55.83 9.89c-51 5.39-94.33 26.13-130.34 61.89l64.37 64.41c48.14-50.35 128.42-47.63 174.33 2.78 42.63 46.81 41.21 120.41-3.36 165.74-46.51 47.31-124.43 48.32-171.33-1.23L.02 424.1a255.45 255.45 0 0 0 37.62 31.44 258.12 258.12 0 0 0 81.33 37c1.65.43 2.4.31 2.76-1.53.48-2.53 1.26-5 1.91-7.48q2.1-7.91 4.18-15.76c56.72 8.2 59.16 9.1 115.5-1.8 3.47 12.57 7 25.17 10.52 38 65-18.58 115.82-56 153.53-111.9l-46.2-31.73a210.81 210.81 0 0 0 23-46 215.79 215.79 0 0 0 11.27-50.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M863.38 605.62a125.45 125.45 0 0 0 50.27 29.6c-10.87 41.5-21.7 82.81-32.59 124.4a252.43 252.43 0 0 1-109.86-62.93q46.22-45.69 92.18-91.07Z",
    transform: "translate(-764.05 -273.57)",
    style: {
      fill: "#fff",
      animation: "blink 4s ease-in infinite",
      animationDelay: "4s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m978.63 637.32 26.85 96.48a226.12 226.12 0 0 1-112.14 1.73l25.85-98.74a127.78 127.78 0 0 0 59.44.53Z",
    transform: "translate(-764.05 -273.57)",
    style: {
      fill: "#fff",
      animation: "blink 4s ease-in infinite",
      animationDelay: "3.5s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.22 667c-24 42.19-93.48 92.9-141.43 103.13L984.7 635.72a126.71 126.71 0 0 0 36.65-17.53 128.54 128.54 0 0 0 29.3-28.46Q1107 628.44 1163.22 667Z",
    transform: "translate(-764.05 -273.57)",
    style: {
      fill: "#fff",
      animation: "blink 4s ease-in infinite",
      animationDelay: "3s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.7 537.15a205.26 205.26 0 0 1-33.23 93.52L1054 585a127.13 127.13 0 0 0 20.43-54.54Z",
    transform: "translate(-764.05 -273.57)",
    style: {
      fill: "#fff",
      animation: "blink 4s ease-in infinite",
      animationDelay: "2.5s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.84 348.44c48.93 52.47 71.34 114.3 67.5 186.1l-116.26-10c2.19-36.19-8.56-67.92-32.71-95.36Z",
    transform: "translate(-764.05 -273.57)",
    style: {
      fill: "#fff",
      animation: "blink 4s ease-in infinite",
      animationDelay: "2s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.72 281.18a262.55 262.55 0 0 1 69.11 47.06L1037.74 424c-5.06-4.08-9.8-8.25-14.9-11.93s-10.45-6.77-16-10.33q27.79-59.98 55.88-120.56Z",
    transform: "translate(-764.05 -273.57)",
    style: {
      fill: "#fff",
      animation: "blink 4s ease-in infinite",
      animationDelay: "1.5s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.33 310.2c2.29 26.4 4.56 52.55 6.85 79-27.92 3.41-52 14.74-71.78 33.27l-57.17-55.57c34.65-32.7 75.05-51.51 122.1-56.7Z",
    transform: "translate(-764.05 -273.57)",
    style: {
      fill: "#fff",
      animation: "blink 4s ease-in infinite",
      animationDelay: ".5s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 307.87q-21.24 45.72-42.48 91.45c-20.86-6.92-18-9.13-58.72-10.89l-8.13-98.75c23.47-5.51 84.57 4.64 109.33 18.19Z",
    transform: "translate(-764.05 -273.57)",
    style: {
      fill: "#fff",
      animation: "blink 4s ease-in infinite",
      animationDelay: "1s"
    }
  }), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes blink{0%,20%,to{fill:#fff}10%{fill:#aec}}")));
};
export default SvgMeduzaLoader;